import React, {useEffect, useState} from 'react';
import {MultiSelectComponent, MultiSelectOption} from "module/CustomField/component/input/MultiSelectComponent";
import {getDqParamsObject} from 'module/CustomField/util/DqParam'
import {CFValue} from 'module/CustomField/type/CFType'
import {searchDq} from 'module/Dq/searchDq'
import {alertServerError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'

type PossibleValues = string | number | null | undefined

export function DqRadioComponent(props: CFComponentProps<CFValue>) {
	const [options, setOptions] = useState<MultiSelectOption<PossibleValues>[]>([])
	const dqkey = props.cfDef.dqKey
	const params = getDqParamsObject(props.cfDef.dqParams, props.model, props.pos)
	useEffect(() => {
		searchDq({dqkey, params}).then((data) => {
			setOptions(data.map(x => ({isButton: true, displayName: x.label, value: x.value})) as MultiSelectOption<PossibleValues>[])
		}).catch(alertServerError)
	}, [dqkey, ...Object.values(params)])
	return <MultiSelectComponent {...props} options={options}/>;
}